/*
 * Chart tokens. Series slots 1 to 3 of the dataviz skill's reference
 * palette, validated with validate_palette.js --mode light --pairs all (all
 * checks pass). Aqua sits below 3:1 against the surface, so every chart that
 * uses it carries a legend and a tooltip. Never more than three series; never
 * cycle these.
 */
export const SERIES = ["#2a78d6", "#eb6834", "#1baf7a"] as const;

/** One-hue blue ramp, light to dark, for magnitude (the heatmap). */
export const SEQUENTIAL = ["#cde2fb", "#9ec5f4", "#6da7ec", "#3987e5", "#256abf", "#184f95", "#0d366b"];

export const EMPTY_CELL = "#f0efec";
export const GRID = "#e1e0d9";
export const AXIS_TEXT = "#52514e";
